import { CONTACT_US_LINK, LINK_WHITEBOARD, SPECIAL_QUOTA_LINK } from './urlLinks';

// Route classification, shared by the app bootstrap (index.js) and the API
// layer (Api/apiUtil.js) so both agree on what "needs a login" means.
//
// The list is fail-closed on purpose: only the pages below are reachable
// without a session, and anything else forces the login flow on landing. A new
// protected page is therefore protected by default.
const PUBLIC_PREFIXES = [
    CONTACT_US_LINK,
    SPECIAL_QUOTA_LINK,
    LINK_WHITEBOARD,
    '/privacypolicy',
    '/terms',
    '/tutorial',
    '/about',
    '/tutoring',
    '/schools',
    '/subscriptions',
    '/onboarding',
    '/features',
    '/signup_consent',
    '/unsubscribe',
];

// Locale-prefixed variants of the same pages: /ro/tutorial, /en/about, ...
const LANGUAGE_PREFIXES = ['/ro', '/en', '/fr', '/it'];

// Prefix match on a path-segment boundary. Plain startsWith would let
// '/aboutthings' match '/about', and '/rooms' match '/ro'.
function isUnder(pathname, prefix) {
    return pathname === prefix || pathname.startsWith(prefix + '/');
}

export function isPublicPage(pathname = window.location.pathname) {
    if (pathname === '/') {
        return true;
    }
    // Localised home pages: /ro, /en/, ...
    if (LANGUAGE_PREFIXES.some((lang) => pathname === lang || pathname === lang + '/')) {
        return true;
    }
    if (PUBLIC_PREFIXES.some((prefix) => isUnder(pathname, prefix))) {
        return true;
    }
    return LANGUAGE_PREFIXES.some((lang) => PUBLIC_PREFIXES.some((prefix) => isUnder(pathname, lang + prefix)));
}

// True for the URLs that must bounce an anonymous visitor into the login flow.
export function requiresLogin(pathname = window.location.pathname) {
    return !isPublicPage(pathname);
}
